import "./MouseflowIdentifier.css";
import React from "react";
import PropTypes from "prop-types";

class MouseflowIdentifier extends React.Component {
    static propTypes = {
        user: PropTypes.object.isRequired
    };

    render() {
        const { altId } = this.props.user;
        return (
            <div className="mouseflow-id" data-mf-replace-inner={altId} />
        );
    }
}

export default MouseflowIdentifier;